import Notify from 'simple-notify'
import 'simple-notify/dist/simple-notify.css'

export const pushNotify = (text: string, title: string) => {

  const lowerTitle = title.toLowerCase();
  const status = lowerTitle === 'error' || lowerTitle === 'ошибка' ? 'error' : 'success';
  new Notify({
    status,
    title: title,
    text: text || '',
    effect: 'fade',
    speed: 300,
    showIcon: true,
    showCloseButton: true,
    autoclose: true,
    autotimeout: 5000,
    notificationsGap: 20,
    type: 'filled',
    position: 'right top'
  })
}

export const getRequestErrorMessage = (error: unknown, fallback: string) => {
  if (!error || typeof error !== 'object' || !('data' in error)) return fallback;

  const data = (error as { data?: unknown }).data;
  if (typeof data === 'string') return data;
  if (!data || typeof data !== 'object') return fallback;

  const payload = data as Record<string, unknown>;
  if (typeof payload.detail === 'string') return payload.detail;

  const values = Object.entries(payload)
    .filter(([key]) => key !== 'id')
    .map(([, value]) => value);
  const message = values.find((value) => typeof value === 'string')
    || values.find((value) => Array.isArray(value) && typeof value[0] === 'string');

  return Array.isArray(message) ? message[0] : message || fallback;
};
